import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const SocialPopup = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasShown = localStorage.getItem("socialPopupShown");
    if (!hasShown) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = (dontShowAgain = false) => {
    setIsOpen(false);
    if (dontShowAgain) {
      localStorage.setItem("socialPopupShown", "true");
    }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
        >
          <div className="relative w-full max-w-md bg-neutral-950 rounded-xl border !border-neutral-800 shadow-xl p-6">
            <button
              onClick={() => handleClose()}
              className="absolute top-4 right-4 text-neutral-400 hover:text-white"
            >
              ✕
            </button>

            <h3 className="text-xl font-mod font-bold text-white mb-4">
              Connect with fellow
              <span className="otaku-color ml-2 text-2xl headingtitle">
                otakus!
              </span>
            </h3>
            {/* <img src="https://media1.tenor.com/m/gdH4hglVqJ4AAAAC/deku.gif" alt="otakufy" className="w-full" /> */}

            <div className="space-y-5 gap-3 flex justify-center items-center">
              <a
                className="cursor-pointer hover:scale-110 transition-all"
                href="https://x.com/otakufy_live"
                target="_blank"
                rel="noopener noreferrer"
                // className="flex items-center space-x-3 p-3 rounded-lg bg-neutral-800 hover:bg-neutral-700 transition-colors"
              >
                <img
                  src="./images/x.png"
                  alt="otakufy"
                  className="w-24 h-24 mt-3"
                />
              </a>
              <a
                className="cursor-pointer hover:scale-110 transition-all"
                href="https://discord.gg/vmPPknetAg"
                target="_blank"
                rel="noopener noreferrer"
                // className="flex items-center space-x-3 p-3 rounded-lg bg-neutral-800 hover:bg-neutral-700 transition-colors"
              >
                <img
                  src="./images/discord.png"
                  alt="discord"
                  className="w-20 h-20 scale-105"
                />
              </a>
              <a
                className="cursor-pointer hover:scale-110 transition-all"
                href="https://www.instagram.com/otakufy.live/"
                target="_blank"
                rel="noopener noreferrer"
                // className="flex items-center space-x-3 p-3 rounded-lg bg-neutral-800 hover:bg-neutral-700 transition-colors"
              >
                <img
                  src="./images/instagram.png"
                  alt="instagram"
                  className="w-24 h-24 scale-105"
                />
              </a>
            </div>

            <div className="mt-6 flex items-center justify-between">
              <button
                onClick={() => handleClose(true)}
                className="font-mod tracking-tight text-sm text-neutral-400 hover:text-white transition-colors"
              >
                Don't show again
              </button>

              <button
                onClick={() => handleClose()}
                className="font-mod  px-4 py-2 bg-neutral-800 text-white rounded-lg hover:bg-neutral-700 transition-colors"
              >
                Maybe later
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SocialPopup;
